import React from 'react';
import BookingItemsAddressComponent from '../booking-items-address/booking-items-address.component';
import BookingItemsFlightComponent from '../booking-items-flight/booking-items-flight.component';
// styles
const styles = require('./booking-items.scss');

interface IProps {
  data: any;
  language: string;
  multiLang: any;
}

interface IState {
  data: any;
}

class BookingItemsComponent extends React.Component<IProps, IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      data: props.data
    };
  }

  public render() {
    const { language, multiLang } = this.props;

    return (
      <div className={styles.pickupDetails}>
        <div className={styles.content}>
          {this.state.data.collectionLocation !== null || this.state.data.deliveryLocation !== null
            ? <BookingItemsAddressComponent language={language} multiLang={multiLang} data={this.state.data}></BookingItemsAddressComponent>
            : null
          }
          {this.state.data.flightDetails !== null
            ? <BookingItemsFlightComponent language={language} multiLang={multiLang} data={this.state.data.flightDetails}></BookingItemsFlightComponent>
            : null
          }
        </div>
      </div>
    );
  }

}

export default BookingItemsComponent;



// WEBPACK FOOTER //
// ./src/components/booking-items/booking-items.component.tsx